import { ROUTES } from '@constants/ROUTES';
import { CoreBox } from '@youscience/core';

import FilterIcon from '@images/filter.svg?react';
import FilledHeartIcon from '@images/heart-filled.svg?react';

import { StyledActionPanelWrap, StyledFiltersLink, StyledFavoritesLink } from './HeaderActions.styles';

interface HeaderActionsProps {
  isTabletScreen: boolean;
  favoritesCount: number;
  onOpenMobileFilters: (event: React.MouseEvent<HTMLElement>) => void;
  mode: 'schools' | 'majors';
}

export const HeaderActions = ({ isTabletScreen, favoritesCount, onOpenMobileFilters, mode }: HeaderActionsProps) => {
  const favoritesRoute = mode === 'schools' ? ROUTES.FAVORITE_SCHOOLS : ROUTES.FAVORITE_MAJORS;

  return (
    <StyledActionPanelWrap>
      {isTabletScreen && (
        <StyledFiltersLink to="#" onClick={onOpenMobileFilters}>
          <FilterIcon />
          <CoreBox component="span" sx={{ ml: 1 }}>
            Filters
          </CoreBox>
        </StyledFiltersLink>
      )}
      <StyledFavoritesLink to={favoritesRoute}>
        <FilledHeartIcon />
        {`Favorites (${favoritesCount})`}
      </StyledFavoritesLink>
    </StyledActionPanelWrap>
  );
};
